import React from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { Switch, Route } from 'react-router';
import SnackbarContainer from '../components/common/SnackbarContainer';
import RakunaTheme from '../components/common/RakunaTheme';
import SignUpSteppers from './SignUpSteppers';

const SignUp = () => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={RakunaTheme}>
      <Switch>
        <Route
          render={props => (
            <SnackbarContainer>
              <SignUpSteppers {...props} />
            </SnackbarContainer>
          )}
        />
      </Switch>
    </ThemeProvider>
  </StyledEngineProvider>
);

export default SignUp;
